import HeroBanner from "../components/HeroBanner";
import TrainingPrograms from "../components/TrainingPrograms";
import ChallengeFriend from "../components/ChallengeFriend";
import Pricing from "../components/Pricing";

export default function Home() {
  return (
    <>
      <HeroBanner />
      <TrainingPrograms />
      <ChallengeFriend />
      <Pricing />
    </>
  );
}
